import { styled } from "styled-components";

const ProgressDotsContainer = styled.div`
  display: flex;
  gap: 8px;
`

const ProgressDot = styled.div<{ $isActive: boolean }>`
  width: 6px;
  aspect-ratio: 1;
  border-radius: 6px;
  background: ${props => props.$isActive ? ({ theme }) => theme.colors.theme.brandColor3 : ({ theme }) => theme.colors.text.neutral};
  transition-duration: 500ms;
  &[data-testid="progress-dot"] {
    // You can add specific test styles here if needed
  }
`

export {
  ProgressDotsContainer,
  ProgressDot,
};
